"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clickguard;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _reactMintl = require("@godaddy/react-mintl");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("./"));
var modal = _interopRequireWildcard(require("./modal"));
var _button = _interopRequireDefault(require("@ux/button"));
var _modal2 = _interopRequireDefault(require("@ux/modal"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * ClickGuard modal.
 *
 * @class Title
 * @api private
 */
class ClickGuard extends _react.Component {
  /**
   * Event handler for cancel or continue button. This will always close the modal,
   * but the original guarded action could still be performed.
   *
   * @param {Boolean} allow Should callback be called
   * @returns {Function} event handler
   * @api private
   */
  close(allow) {
    const props = this.props;
    return () => {
      this.ref.close();

      //
      // Continue button was clicked, call the supplied callback.
      //
      if (allow) {
        props.callback(props.event);
      }
    };
  }

  /**
   * Modal title, fallback to default.
   *
   * @returns {React.ReactElement} title
   * @api private
   */
  get title() {
    return this.props.title || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:AccountDelegation:deny-all-title"
    });
  }

  /**
   * Modal footer buttons.
   *
   * @returns {React.ReactElement[]} both cancel and continue button
   * @api private
   */
  get footer() {
    return [/*#__PURE__*/_react.default.createElement(_button.default, {
      key: "cancel",
      onClick: this.close(),
      text: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "Shared:AccountDelegation:cancel"
      })
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: "continue",
      onClick: this.close(true),
      text: this.props.caption || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "Shared:AccountDelegation:continue"
      })
    })];
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_modal2.default, {
      ref: c => {
        this.ref = c;
      },
      title: this.title,
      id: "click-guard-modal",
      footer: this.footer
    }, this.props.message || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:AccountDelegation:deny-all-msg"
    }));
  }
}

/**
 * Custom clickguard modal properties.
 *
 * @enum {Object}
 * @api public
 */
ClickGuard.propTypes = {
  /** modal text contents */
  message: _propTypes.default.string,
  /** text for the continue button */
  caption: _propTypes.default.string,
  /** title for the modal */
  title: _propTypes.default.string,
  /** called when the continue button was clicked */
  callback: _propTypes.default.func,
  /** event passed as argument to callback */
  event: _propTypes.default.any
};

/**
 * Setup event listener to intercept events when account delegation is active.
 *
 * @param {Object} messages Internationalized strings.
 * @param {Object} props Additional properties required for customized modal
 * @param {Function} done Completion callback
 * @returns {Function} Event listener
 * @api private
 */
function clickguard(messages, props = {}, done) {
  if (typeof props === 'function') {
    done = props;
    props = {};
  }
  return function handle(event) {
    if (!_.default.active) {
      return done(event);
    }
    modal.render(/*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(ClickGuard, (0, _extends2.default)({}, props, {
      event: event,
      callback: done
    }))));
  };
}